<template>
  <div>
    <div class="page-header-wrapper">
      <PageHeader title="My Content"></PageHeader>
      <el-form class="filter-form filter-wrapper" label-position="left">
        <el-form-item
          class="select-date-range"
          label="Please select date range"
        >
          <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            type="daterange"
            start-placeholder="Begin date"
            end-placeholder="End date"
            @change="onDateRangeChange"
          >
          </el-date-picker>

        </el-form-item>
        <el-form-item>
          <div class="filter-actions">
            <el-input
              prefix-icon="el-icon-search"
              placeholder="Search"
              v-model="searchVal"
              v-debounce="onSearch"
              clearable
              @clear="onSearch"
            />
            <el-button
              v-role="[2, 3, 5, 7, 9, 11,13]"
              type="primary"
              icon="el-icon-plus"
              @click="openPaperDialog()"
            >
              New Content
            </el-button>
            <!-- <el-button
              v-role="[2, 3, 5, 7, 9, 11,13]"
              type="primary"
              icon="el-icon-plus"
              @click="newPaperDialogVisible2 = true"
            >
              New Content(旧)
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
        @sort-change="onSortChange"
        @select="handleSelect"
        @select-all="handleSelectionAll"
      >
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column
          prop="FileName"
          label="Content Name"
          sortable="custom"
          min-width="180"
        >
          <template #default="{ row }">
            <a :href="row.AttachmentPath" target="_blank">{{ row.FileName }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="CategoryName"
          label="Category"
          sortable="custom"
          min-width="130"
        />
        <el-table-column
          prop="LevelName"
          label="Security Level"
          sortable="custom"
          min-width="140"
        />
        <el-table-column
          prop="CreatedOn"
          label="Create Date"
          sortable="custom"
          filter-multiple
          :formatter="rowDateFormatter"
          min-width="135"
        />
        <el-table-column
          prop="NoPush"
          label="No.Push"
          sortable="custom"
          min-width="110"
        />
        <el-table-column
          prop="UvIsRead"
          label="UV.Is Read"
          sortable="custom"
          min-width="120"
        />
        <el-table-column
          prop="RateOfHits"
          label="Rate of hits"
          sortable="custom"
          min-width="130"
        />
        <el-table-column
          prop="NoDownloads"
          label="No.Downloads"
          sortable="custom"
          min-width="150"
        />
         <el-table-column
          prop="UvDuration"
          label="UV.Duration(s)"
          sortable="custom"
          min-width="160"
        />

        <el-table-column
          prop=""
          label="Operation"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem
                icon="el-icon-edit"
                title="Edit"
                @click="handleEdit(row)"
              />
              <OptionMenuItem
                v-role="[2, 3, 5, 7, 9, 11,13]"
                icon="el-icon-delete"
                title="Delete"
                @click="handleDeletePaper(row)"
              />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <div class="actions">
          <el-button
            v-role="[2, 3, 5, 7, 9, 11,13]"
            type="text"
            icon="el-icon-delete"
            size="medium"
            @click="handleDeletePapers()"
            :disabled="multipleSelection.length === 0"
          >
            Delete Content(s)
          </el-button>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <PaperDialog
      :visible.sync="paperDialogVisible"
      @success="onSuccess(true)"
      :data.sync="rowData"
    />
    <NewPaperDialog2
      :visible.sync="newPaperDialogVisible2"
      @success="onSuccess(true)"
    />
    <UploadContentDialog
      :visible.sync="uploadContentDialogVisible"
      @success="onSuccess(true)"
    />
    <ViewContentDialog
      :visible.sync="viewDialogVisible"
      :data.sync="rowData"
      @success="onSuccess"
    />
    <UpdateContentDialog
      :visible.sync="updateContentDialogVisible"
      :data.sync="rowData"
      @success="onSuccess"
    />
    <UpdatePaperDialog
      :visible.sync="updatePaperDialogVisible"
      :data.sync="rowData"
      @success="onSuccess"
    />
    <UpdateMeetingDialog
      :visible.sync="updateMeetingDialogVisible"
      :data.sync="rowData"
      @success="onSuccess"
    />
  </div>
</template>
<script>
import moment from "moment";
import PaperDialog from "./content/paper-dialog";
import NewPaperDialog2 from "./new-paper-dialog";
import UploadContentDialog from "./upload-content-dialog";
import ViewContentDialog from "./view-content-dialog";
import UpdateContentDialog from "./update-content-dialog";
import UpdatePaperDialog from "./update-paper-dialog";
import UpdateMeetingDialog from "./update-meeting-dialog";

export default {
  name: "My-Content",
  components: {
    PaperDialog,
    UploadContentDialog,
    ViewContentDialog,
    UpdateContentDialog,
    UpdatePaperDialog,
    UpdateMeetingDialog,
    NewPaperDialog2
  },
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      dateFormat: "YYYY-MM-DD",
      orderBy: "CreatedOn",
      orderType: "descending",
      viewDialogVisible: false,
      multipleSelection: [],
      dateRange: [],
      paperDialogVisible: false,
      uploadContentDialogVisible: false,
      updateContentDialogVisible: false,
      updatePaperDialogVisible: false,
      updateMeetingDialogVisible: false,
      rowData: null,
      newPaperDialogVisible2:false,
      value1: ''
    };
  },
  computed: {
    previewUrl() {
      return `${process.env.VUE_APP_SERVER}/upload/paper/`;
    },
    role() {
      return this.$store.state.role;
    },
    fromDate() {
      return this.dateRange?.length > 0 ? this.dateRange[0] : "";
    },
    toDate() {
      return this.dateRange?.length > 0 ? this.dateRange[1] : "";
    },
  },
  created() {
    // const currentDate = this.moment();
    // const firstDayOfMonth = currentDate.format("YYYY-MM-01");
    // const today = currentDate.format("YYYY-MM-DD");
    // this.dateRange = [firstDayOfMonth, today];
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
      }
    });
  },
  methods: {
    openPaperDialog(row) {
      this.rowData = row || null;
      this.paperDialogVisible = true;
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    onDateRangeChange() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      this.axios
        .get(`/content/contentList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    searchTime() {
      this.getTableData();
    },
    handleSelect(selection, row) {
      let index = this.multipleSelection.findIndex(
        (PaperID) => PaperID === row.PaperID
      );
      if (index === -1) {
        this.multipleSelection.push(row.PaperID);
      } else {
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectionAll(select) {
      if (select.length > 0) {
        let paperIds = Array.from(select, (i) => i.PaperID);
        let result = paperIds.filter((x) => {
          return !this.multipleSelection.some((y) => y === x);
        });
        this.multipleSelection = this.multipleSelection.concat(result);
      } else {
        let paperIds = Array.from(this.tableData, (i) => i.PaperID);
        paperIds = paperIds.filter((x) => {
          return this.multipleSelection.some((y) => y === x);
        });
        let result = this.multipleSelection.filter((x) => {
          return !paperIds.some((y) => y === x);
        });
        this.multipleSelection = result;
      }
    },
    toggleRowSelection() {
      let rows = this.tableData.filter((i) => {
        return this.multipleSelection.some((PaperID) => PaperID === i.PaperID);
      });
      rows.forEach((row) => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true);
        });
      });
    },
    rowDateFormatter(row, column, cellValue) {
      return moment(new Date(cellValue)).format(this.dateFormat);
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    onSuccess(resetPage = false) {
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleEdit(row) {
      this.openPaperDialog(row);
    },
    viewContentDialog(row) {
      this.rowData = row;
      this.viewDialogVisible = true;
    },
    handleDeletePaper(row) {
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.axios
          .post("/content/delete", {
            contentId: [row.PaperID],
          })
          .then((res) => {
            if (res.code === 200) {
              this.getTableData();
              this.$message.success("Delete paper successfully");
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    handleDeletePapers() {
      this.$confirm(
        "Please make sure if it is ready to delete selected content(s)?",
        "Attention",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
        }
      ).then(() => {
        this.axios
          .post("/content/delete", {
            contentId: this.multipleSelection,
          })
          .then((res) => {
            if (res.code === 200) {
              this.getTableData();
              this.multipleSelection = [];
              this.$message.success("Delete content(s) successfully");
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-form {
  padding-top: 0px !important;
  display: flex;
  align-items: flex-end;
  .select-date-range {
    flex: 1;
    .date-picker {
      width: 200px !important;
      padding: 3px 5px;
      justify-content: center;
      ::v-deep {
        .el-range-separator {
          padding: 0;
        }
        .el-range__close-icon {
          // display: none;
        }
      }
    }
  }
  .filter-actions {
    display: flex;
    .el-input + .el-button {
      margin-left: 10px;
    }
  }
}
.pagination-wrap {
  display: flex;
  justify-content: space-between;
  .actions {
    display: flex;
  }
  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}

.attachment-link {
  display: flex;
  justify-content: center;
}
</style>
